angular.module('impactx.sidebar').controller('SideNavCtrl', [
    '$context',
    '$scope',
    'dataGen',
    '$config',
    '$workspace',
    'sidebarShow',
    '$timeout',
    'ThemeWorldService',
    'LegalLinking',
    'AppConfiguration',
    'TranslationService',
    SideNavController]);
function SideNavController($context, $scope, dataGen, $config, $workspace, sidebarShow, $timeout, ThemeWorldService, LegalLinking, AppConfiguration, TranslationService) {
    this.sidebarShow = sidebarShow;
    $scope.changeMenu = false;
    var showPromise;
    this.currentYear = AppConfiguration.get('copyRightYear');
    $scope.imprintURL = AppConfiguration.get('imprintURL');
    $scope.privacyPolicy = AppConfiguration.get('privacyPolicy');
    $scope.generalTerms = AppConfiguration.get('generalTerms');
    $scope.smallMenuEnabled = AppConfiguration.get('smallMenuEnabled');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    $scope.translations = TranslationService;

    $scope.activate = function(workspace) {
        $workspace.activateWorkspace(workspace, $workspace, dataGen);
        $scope.changeMenu = false;
    };

    $scope.getCurrentWorkspaceId = function() {
        return $workspace.getCurrentWorkspaceId().value;
    };

    $scope.getCurrentWorkspace = function() {
        return $workspace.getCurrentWorkspace($workspace);
    };

    $scope.getCurrentWorkspaceView = function() {
        return "#/" + $workspace.getCurrentWorkspace($workspace).view;
    };

    $scope.getAvailableWorkspaces = function() {
        return $workspace.availableWorkspaces;
    };

    $scope.hasOtherWorkspaces = function() {
        return $workspace.hasOtherWorkspaces($workspace);
    };

    $scope.getSideBar = function() {
        return $context.sideBar;
    };

    $scope.toggleChangeMenu = function() {
        $scope.changeMenu = !$scope.changeMenu;
    };

    $scope.setChangeMenuTrue = function() {
        $scope.changeMenu = true;
    };

    $scope.cancelPromise = function() {
        $timeout.cancel(showPromise);
    };

    $scope.setChangeMenuFalse = function() {
        showPromise = $timeout(function() {
            $scope.changeMenu = false;
        }, 1000);
    };

    $scope.getIconClass = function(workspace) {
        return $config.getIconClass(workspace);
    };

    $scope.getTheme = function (workspace) {
        if (workspace.key === "shop" && ThemeWorldService.getCurrentThemeWorldSearch()) {
            return ThemeWorldService.getCurrentThemeWorldSearch();
        }
        else {
            return workspace.key + $context.getSuffixForTheme();
        }
    };

    $scope.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };

}